import { Button, IconName } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { useAddPolicyExceptionDialogForm } from '../../../../forms';

export const AddPolicyExceptionButton = () => {
    const [renderDialog, toggleDialog] = useAddPolicyExceptionDialogForm();

    return (
        <>
            <Button icon={IconName.Add} size="small" onClick={toggleDialog} type="submit">
                {lt('RateGroupPolicyExceptionsSectionAddException')}
            </Button>
            {renderDialog()}
        </>
    );
};
